<script lang="ts" setup>
    import { ref, onMounted, watch } from 'vue'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'

    interface User {
        id: string
        displayName: string
    }

    const props = defineProps({
        modelValue: {
            type: Number,
            default: null,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    })

    const emit = defineEmits(['update:modelValue'])

    const users = ref<User[]>([])
    const value = ref(props.modelValue)

    const fetch = async () => {
        const res = await axios.get('UserList')
        users.value = res.data
    }

    onMounted(() => {
        fetch()
    })

    watch(
        () => props.modelValue,
        newValue => {
            value.value = newValue
        }
    )

    watch(value, newValue => {
        emit('update:modelValue', newValue)
    })
</script>

<template>
    <el-select size="large" filterable class="w-100" v-model="value" placeholder="Select user" :clearable="clearable">
        <el-option v-for="user in users" :key="user.id" :label="user.displayName" :value="user.id"> </el-option>
        <template #prefix>
            <i class="ti ti-user"></i>
        </template>
    </el-select>
</template>
